import React from 'react';
import iconsObject from './Icons';
import { DarwinFlex } from '../Flex';

export type IconName = keyof typeof iconsObject;

interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
  name: IconName;
  size?: keyof typeof sizeMap | number;
}

const sizeMap = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 28,
  xxl: 30,
  xxxl: 32,
};

type IconComponentType = React.MemoExoticComponent<
  React.FC<React.SVGProps<SVGSVGElement>>
>;

const icons: Record<IconName, IconComponentType> = iconsObject;

const Icon: React.FC<IconProps> = ({ name, size = 'md', ...props }) => {
  const SvgIcon = icons[name];
  const computedSize = typeof size === 'number' ? size : sizeMap[size];

  if (!SvgIcon) return null;

  return (
    <DarwinFlex
      align="center"
      justify="center"
      style={{
        width: computedSize,
        height: computedSize,
      }}
    >
      <SvgIcon height="100%" {...props} />
    </DarwinFlex>
  );
};

export default Icon;
